<template>
  <div class="positionList addCommon" style="height: 100%">
    <div class="return">
      <i class="el-icon-back" @click="goReturn">{{$t('LanguageLib.Return')}}</i>
      <span class="border"></span>
      <span class="title">{{ titleType }}</span>
    </div>
    <div class="content">
      <div class="operationBtn">
        <el-button @click="delPosition()" :disabled="delDisabled">{{$t('LanguageLib.DELETE')}}</el-button>
        <el-button type="primary" @click="createPosition">{{$t('LanguageLib.ADD_TO')}}</el-button>
        <el-input
          placeholder=""
          prefix-icon="el-icon-search"
          v-model="searchValPosition"
          @keyup.enter.native="searchPositionList"
        >
        </el-input>
      </div>
      <p style="margin-bottom: 15px;color: #666666;font-size: 12px;">
        {{$t('LanguageLib.CurrentDefaultPosition')}}
        <span v-if="!$commonfun.iswx(defaultDomainName) || !JSON.parse($commonfun.localStorage.getitem('qyuser'))">{{defaultDomainName}}&nbsp;{{defaultRoleName}}</span>
        <span v-if="$commonfun.iswx(defaultDomainName) && JSON.parse($commonfun.localStorage.getitem('qyuser'))"><ww-open-data slot="content" type="departmentName" :openid="defaultDomainName.slice(3)"></ww-open-data>&nbsp;{{defaultRoleName}}</span>
      </p>
      <div class="tableWarp">
        <div class="tableParent">
          <el-table
            empty-text=" "
            :data="tableData"
            stripe
            @selection-change="selectionChange"
            @cell-mouse-enter="cellmouseEnter"
            @cell-mouse-leave="cellmouseLeave"
            @sort-change='sortChangePosition'
            style="width: auto;"
            v-loading="loading"
            :default-sort="defaultSort"
            ref="table"
            height="100%">
            <el-table-column
              type="selection"
              width="45">
            </el-table-column>
            <el-table-column
              prop="1"
              :label="$t('LanguageLib.ROLE_NAME')"
              sortable="custom"
              min-width="60">
              <template slot-scope="scope">
                <el-tooltip effect="light" placement="top-start" >
                  <span slot="content" type="roleName">{{scope.row.roleName}}</span>
                  <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="roleName">{{scope.row.roleName}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              prop="2"
              :label="$t('LanguageLib.JOB_TITLE')"
              sortable="custom"
              min-width="150">
              <template slot-scope="scope">
                <el-tooltip effect="light" placement="top-start">
                  <!-- <span v-if="!$commonfun.iswx(scope.row.domainName) || !JSON.parse($commonfun.localStorage.getitem('qyuser'))" slot="content" type="postionName">{{scope.row.postionName}}</span>
                  <span v-if="!$commonfun.iswx(scope.row.domainName) || !JSON.parse($commonfun.localStorage.getitem('qyuser'))" ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="postionName">{{scope.row.postionName}}</span> -->
                  <span v-if="!$commonfun.iswx(scope.row.domainName)" slot="content" type="postionName">{{scope.row.domainName}}&nbsp;{{scope.row.roleName}}</span>
                  <span v-if="!$commonfun.iswx(scope.row.domainName)" ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="postionName">{{scope.row.domainName}}&nbsp;{{scope.row.roleName}}</span>
                  <span v-if="!$commonfun.iswx(scope.row.domainName) && !JSON.parse($commonfun.localStorage.getitem('qyuser'))" slot="content" type="postionName">{{scope.row.domainName}}&nbsp;{{scope.row.roleName}}</span>
                  <span v-if="!$commonfun.iswx(scope.row.domainName) && !JSON.parse($commonfun.localStorage.getitem('qyuser'))" ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="postionName">{{scope.row.domainName}}&nbsp;{{scope.row.roleName}}</span>
                  <span v-if="$commonfun.iswx(scope.row.domainName) && JSON.parse($commonfun.localStorage.getitem('qyuser'))" slot="content" type="postionName"><ww-open-data slot="content" type="departmentName" :openid="scope.row.domainName.slice(3)"></ww-open-data>&nbsp;{{scope.row.roleName}}</span>
                  <span v-if="$commonfun.iswx(scope.row.domainName) && JSON.parse($commonfun.localStorage.getitem('qyuser'))" ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="postionName"><ww-open-data slot="content" type="departmentName" :openid="scope.row.domainName.slice(3)"></ww-open-data>&nbsp;{{scope.row.roleName}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              prop="0"
              :label="$t('LanguageLib.ADD_DATE')"
              sortable="custom"
              min-width="150">
              <template slot-scope="scope">
                <el-tooltip effect="light" placement="top-start">
                  <span slot="content" type="addDate">{{$commonfun.formatDate(scope.row.addDate, '1')}}</span>
                  <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="addDate">{{$commonfun.formatDate(scope.row.addDate, '1')}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              :label="$t('LanguageLib.SetDefaultPosition')"
              min-width="100">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.isDefaultPostion == true"
                  type="text"
                  style="color:#666666;border: 1px solid #EBEEF5;padding:7px 10px;color: #3BC6B9;background: rgba(59, 198, 185, 0.15);border: 1px solid #3bc6b9;">
                  {{$t('LanguageLib.DefaultPosition')}}
                </el-button>
                <el-button
                  v-if="scope.row.isDefaultPostion == false && showIcon==true&&scope.row.id==rowid"
                  @click.native.prevent="setDefaultPosition(scope.row, scope.$index, tableData)"
                  type="text"
                  style="color:#666666;border: 1px solid #EBEEF5;padding:7px 10px;">
                  {{$t('LanguageLib.SET_DEFAULT')}}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          @size-change="handleSizeChangePosition"
          @current-change="handleCurrentChangePosition"
          :current-page="currentPage"
          :page-sizes="[20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal">
        </el-pagination>
      </div>
      <el-dialog :title="$t('LanguageLib.JOB_INFORMATION')" :visible.sync="dialogPosition" class="createPositionDialog dialogAdd" :before-close="closeDialog" :close-on-click-modal="false">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <el-form-item :label="$t('LanguageLib.ORGANIZATION')" prop="DomainId" style="position: relative">
            <el-input
              class="TeInput"
              :readonly="true"
              v-model="DomainName"
               :placeholder="$t('LanguageLib.PLEASE_CHOOSE')"
            >
            <el-button @click="openOrgList" slot="append" :style="styleStr" icon="el-icon-more"></el-button>
          </el-input>
          <span v-if="DomainName.slice(0, 3) === 'wx|' && JSON.parse($commonfun.localStorage.getitem('qyuser'))"  style="cursor: no-drop;display: inline-block;width: calc(100% - 72px);height: 38px;position: absolute;background-color: #fff;left: 1px;top: 1px;border-radius: 5px;">
            <ww-open-data style="position: absolute;top: 0px;left: 14px;height: 38px;line-height: 38px;width: calc(100% - 14px);overflow: hidden;"  type="departmentName" :openid="DomainName.slice(3)"></ww-open-data>
          </span>
          </el-form-item>
          <div class="parent" style="position: relative;">
            <el-form-item :label="$t('LanguageLib.ROLES')" prop="RoleId">
              <el-select style="width: 100%;" filterable v-model="ruleForm.RoleId" clearable :placeholder="$t('LanguageLib.PLEASE_CHOOSE')" @change="changeRole">
                <el-option
                  v-for="item in roleList"
                  :key="item.roleId"
                  :label="item.roleName"
                  :value="item.roleId">
                </el-option>
              </el-select>
              <el-checkbox v-model="roleFilter" @change="changeRoleFilter">{{$t('LanguageLib.z_info_common_000084')}}</el-checkbox>
            </el-form-item>
            <el-form-item style="position: absolute;top: 40px; left: 0;width: 100%;" v-if="ruleForm.DomainId == ''">
              <el-input style="width: 100%;" :readonly="true" :placeholder="$t('LanguageLib.PLEASE_CHOOSE')" @click.native="showTit">
              </el-input>
            </el-form-item>
          </div>
          <el-form-item :label="$t('LanguageLib.POSITION')">
            <span v-if="positionDomainName.slice(0, 3) !== 'wx|' || !JSON.parse($commonfun.localStorage.getitem('qyuser'))" style="position: relative;font-size: 14px;display: inline-block;width: calc(100% - 22px);padding: 0 10px;overflow: hidden;height: 41px;background: #F5F7FA;color: #C0C4CC;border-radius: 4px;border: 1px solid #E4E7ED;">
              {{positionDomainName}}&nbsp;{{positionRoleName}}
            </span>
            <span v-if="positionDomainName.slice(0, 3) === 'wx|' && JSON.parse($commonfun.localStorage.getitem('qyuser'))" style="position: relative;font-size: 14px;display: inline-block;width: calc(100% - 22px);padding: 0 10px;overflow: hidden;height: 41px;background: #F5F7FA;color: #C0C4CC;border-radius: 4px;border: 1px solid #E4E7ED;">
              <ww-open-data style="height: 38px;width: calc(100% - 14px);overflow: hidden;"  type="departmentName" :openid="positionDomainName.slice(3)"></ww-open-data>&nbsp;{{positionRoleName}}
            </span>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submit('ruleForm')" :loading="loadingSave">{{$t('LanguageLib.DETERMINE')}}</el-button>
        </div>
      </el-dialog>
      <!--所在组织-->
      <el-dialog :title="$t('LanguageLib.SelectOrganization')" :visible.sync="dialogTableVisible" width="360px !important" class="currentOrg">
        <DomainTree @addcheck-treedata="getTreeCheckData" :orgData="orgData" :orgTreeData="orgTreeData" :oneNodeArr="oneNodeArr"></DomainTree>
        <el-button style="float:right;margin-top:15px;" @click="keepOrgData" type="primary" class="searchBtn">{{$t('LanguageLib.DETERMINE')}}</el-button>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import basicdataApi from '../../api/basicdata'
import DomainTree from '@/components/DomainTree.vue'
export default {
  name: 'AddStore',
  components: { DomainTree },
  props: ['currentPage', 'pageSize', 'parentId', 'searchText', 'sort', 'sortOrder', 'checkedStoreTypeData', 'checkedModeOperationData', 'checkedBrandData', 'orgName', 'type', 'sortNumber', 'orgTypeid', 'remark'],
  data () {
    var checkDomainId = (rule, value, callback) => {
      if (!value) {
        this.styleStr = 'width: 70px;height:40px;border-bottom: 1px solid #F56C6C;border-top: 1px solid #F56C6C;border-right: 1px solid #F56C6C;border-radius: 0 4px 4px 0;background-color: #D8DCE6;'
        return callback(new Error(this.$t('LanguageLib.ORGANIZATION') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
      } else {
        this.styleStr = 'width: 70px;height:40px;border-bottom: 1px solid #dcdfe6;border-top: 1px solid #dcdfe6;border-right: 1px solid #dcdfe6;border-radius: 0 4px 4px 0;background-color: #D8DCE6;'
        callback()
      }
    }
    var checkRoleId = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('LanguageLib.ROLES') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
      } else {
        callback()
      }
    }
    return {
      loading: true, // loading状态
      titleType: this.$t('LanguageLib.JOB_INFORMATION'),
      styleStr: 'width: 70px;height:40px;border-bottom: 1px solid #dcdfe6;border-top: 1px solid #dcdfe6;border-right: 1px solid #dcdfe6;border-radius: 0 4px 4px 0;background-color: #D8DCE6;',
      delDisabled: true, // 删除按钮默认禁用
      selectPositionData: [], // 选中的职位数据
      dialogPosition: false, // 是否显示添加职位
      defaultDomainName: '', // 当前默认职位组织
      showIcon: false, // 是否显示设为默认按钮
      rowid: '', // 当前行的id
      defaultRoleName: '', // 当前默认职位角色
      tableData: [], // 列表数据
      pageTotal: 0, // 数据总数
      roleFilter: false, // 角色过滤
      defaultSort: { prop: '0', order: 'ascending' }, // 默认显示排序
      prevSort: 'ascending', // 记录前一次的排序状态（elementUI默认有三种，即descending，ascending和null）
      prevProp: '0', // 记录前一次的prop值
      getPositionlist: (pageIndex, pageSize, sort, isAsc, userId, searchVal) => {
        this.loading = true
        // 请求列表接口数据
        basicdataApi.userUplist('post', '/user/uplist', { pageIndex, pageSize, sort, isAsc, userId, searchVal })
          .then(res => {
            this.tableData = res.data.data
            this.pageTotal = res.data.total
            for (let i = 0; i < this.tableData.length; i++) {
              this.tableData[i].show = false
            }
            if (res.data.defaultDomainName && res.data.defaultRoleName) {
              this.defaultDomainName = res.data.defaultDomainName
              this.defaultRoleName = res.data.defaultRoleName
            } else {
              this.defaultDomainName = ''
              this.defaultRoleName = ''
            }
            this.loading = false
          })
          .catch(err => {
            this.$commonfun.console.log(err)
          })
      }, // 请求数据列表的函数
      getPositionName: () => {
        if (this.DomainName && this.DomainName !== '' && this.ruleForm.RoleId && this.ruleForm.RoleId !== '') {
          for (let i = 0; i < this.roleList.length; i++) {
            if (this.ruleForm.RoleId === this.roleList[i].roleId) {
              this.positionRoleName = this.roleList[i].roleName
              this.positionDomainName = this.DomainName
            }
          }
        } else {
          this.positionDomainName = ''
          this.positionRoleName = ''
        }
      }, // 获取添加职位时的职位名称
      currentPagePosition: 1, // 默认显示第1页数据
      pageSizePosition: 20, // 默认每页显示20条数据
      sortPosition: 0, // 排序字段
      isAscPosition: true, // 排序方式逆序：false正序true
      searchValPosition: '', // 模糊搜索
      userIdPosition: this.$route.query.userId, // 人员id
      DomainName: '', // 添加职位时的所在组织名称
      RoleName: '', // 添加职位时的角色名称
      positionRoleName: '', // 添加职位时的职位角色名称
      positionDomainName: '', // 添加职位时的职位组织名称
      roleList: [], // 角色列表
      ruleForm: {
        DomainId: '',
        RoleId: '',
        UserId: this.$route.query.userId
      },
      rules: {
        DomainId: [
          { validator: checkDomainId, trigger: 'change' }
        ],
        RoleId: [
          { validator: checkRoleId, trigger: 'change' }
        ]
      },
      dialogTableVisible: false, // 组织树视图的显示和隐藏
      orgData: [], // 所在组织
      orgTreeData: [], // 所在组织
      oneNodeArr: [], // 所在组织
      addCheckDomainName: '', // 所在组织
      addCheckDomainId: '', // 所在组织
      loadingSave: false // 保存按钮加loding
    }
  },
  created () {
    this.getPositionlist(this.currentPagePosition, this.pageSizePosition, this.sortPosition, this.isAscPosition, this.userIdPosition, this.searchValPosition)
  },
  methods: {
    // 返回
    goReturn () {
      this.$router.push('/basicdata/personnelmanagement?currentPage=' + this.$route.query.currentPage + '&pageSize=' + this.$route.query.pageSize + '&checkDomainId=' + this.$route.query.checkDomainId + '&searchText=' + this.$commonfun.encodeUrl(this.$route.query.searchText) + '&sort=' + this.$route.query.sort + '&isAsc=' + this.$route.query.isAsc + '&gender=' + this.$route.query.gender + '&roleIds=' + this.$route.query.roleIds + '&ranks=' + this.$route.query.ranks + '&isAdmin=' + this.$route.query.isAdmin + '&isLoginProtection=' + this.$route.query.isLoginProtection + '&isLock=' + this.$route.query.isLock + '&fromPath=addPerson')
    },
    // 列表排序
    sortChangePosition (column) {
      if (column.order !== null) {
        this.prevSort = column.order
        if (column.order === 'ascending') {
          this.isAscPosition = true
          this.prevSort = 'ascending'
        } else if (column.order === 'descending') {
          this.prevSort = 'descending'
          this.isAscPosition = false
        }
        if (this.prevProp !== column.prop) {
          var columns = this.$refs.table.columns.find(item => item.property === this.prevProp)
          columns.order = ''
        }
      }
      if (column.order === null) {
        column.column.order = this.prevSort === 'descending' ? 'ascending' : 'descending'
        column.order = this.prevSort === 'descending' ? 'ascending' : 'descending'
        this.prevProp = column.prop
        this.prevSort = column.column.order
        this.isAscPosition = column.column.order !== 'descending'
      }
      this.sortPosition = Number(column.prop)
      // 请求列表接口数据
      this.getPositionlist(this.currentPagePosition, this.pageSizePosition, this.sortPosition, this.isAscPosition, this.userIdPosition, this.searchValPosition)
    },
    // 鼠标移入当前行
    cellmouseEnter (row) {
      this.showIcon = true
      this.rowid = row.id
    },
    // 鼠标移出当前行
    cellmouseLeave (row) {
      this.showIcon = false
    },
    // 页数改变
    handleSizeChangePosition (val) {
      this.pageSizePosition = val
      // 请求列表接口数据
      this.getPositionlist(this.currentPagePosition, this.pageSizePosition, this.sortPosition, this.isAscPosition, this.userIdPosition, this.searchValPosition)
    },
    // 每页条数改变
    handleCurrentChangePosition (val) {
      this.currentPagePosition = val
      // 请求列表接口数据
      this.getPositionlist(this.currentPagePosition, this.pageSizePosition, this.sortPosition, this.isAscPosition, this.userIdPosition, this.searchValPosition)
    },
    // 列表模糊搜索
    searchPositionList () {
      this.currentPagePosition = 1
      // 请求列表接口数据
      this.getPositionlist(this.currentPagePosition, this.pageSizePosition, this.sortPosition, this.isAscPosition, this.userIdPosition, this.searchValPosition)
    },
    // 设置默认职位
    setDefaultPosition (data, index, tableData) {
      basicdataApi.setDefaultPosition('get', '/user/settingudp?userId=' + this.userIdPosition + '&postionId=' + data.postionId)
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t('LanguageLib.DefaultPositionChangeTo') + '"' + data.postionName + '"'
          })
          this.getPositionlist(this.currentPagePosition, this.pageSizePosition, this.sortPosition, this.isAscPosition, this.userIdPosition, this.searchValPosition)
        })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
    },
    // 添加职位
    createPosition () {
      this.dialogPosition = true
      this.ruleForm.DomainId = ''
      this.ruleForm.RoleId = ''
      this.DomainName = ''
      this.positionDomainName = ''
      this.positionRoleName = ''
      this.styleStr = 'width: 70px;height:40px;border-bottom: 1px solid #dcdfe6;border-top: 1px solid #dcdfe6;border-right: 1px solid #dcdfe6;border-radius: 0 4px 4px 0;background-color: #D8DCE6;'
      this.roleFilter = false
    },
    // 选择角色
    changeRole () {
      this.getPositionName()
    },
    // 角色列表过滤
    changeRoleFilter () {
      this.ruleForm.RoleId = ''
      if (this.ruleForm.DomainId !== '') {
        // 获取角色列表
        basicdataApi.getRolesList('get', '/role/udplist?domainId=' + this.ruleForm.DomainId + '&isOnlyDTR=' + this.roleFilter)
          .then(value => {
            this.roleList = value.data // 角色列表
          })
          .catch(err => {
            this.$commonfun.console.log(err)
          })
      }
      this.getPositionName()
    },
    // 打开所在组织组织树视图
    openOrgList () {
      this.dialogTableVisible = true
      // 获取组织树列表
      basicdataApi.gettreelist('get', '/sysdomain/domainTree?showStore=' + true)
        .then(res => {
          this.orgData = res.data
          this.orgTreeData = this.$commonfun.toTree(res.data, 'childDomainTrees', 'id', 'parentDomainId')
          this.oneNodeArr.push(this.orgTreeData[0].id)
        })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
    },
    // 树组件传过来的数据-所在组织
    getTreeCheckData (data) {
      this.addCheckDomainName = data.domainName
      this.addCheckDomainId = data.id
    },
    // 保存树数据-所在组织
    keepOrgData () {
      this.dialogTableVisible = false
      this.DomainName = this.addCheckDomainName
      this.ruleForm.DomainId = this.addCheckDomainId
      // 获取角色列表
      this.ruleForm.RoleId = ''
      basicdataApi.getRolesList('get', '/role/udplist?domainId=' + this.ruleForm.DomainId + '&isOnlyDTR=' + this.roleFilter)
        .then(value => {
          this.roleList = value.data // 角色列表
        })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
      this.getPositionName()
    },
    // 关闭对话框  清除校验
    closeDialog () {
      this.dialogPosition = false
      this.$refs.ruleForm.resetFields()
      this.DomainName = ''
      this.roleFilter = false
    },
    // 保存职位
    submit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadingSave = true
          basicdataApi.CreatePosition('post', '/user/saveudp', this.ruleForm)
            .then(res => {
              this.$message({
                type: 'success',
                message: this.$t('LanguageLib.ADDED_SUCCESSFULLY1')
              })
              this.dialogPosition = false
              this.getPositionlist(this.currentPagePosition, this.pageSizePosition, this.sortPosition, this.isAscPosition, this.userIdPosition, this.searchValPosition)
              this.loadingSave = false
            })
            .catch(err => {
              this.loadingSave = false
              this.$commonfun.console.log(err)
            })
        } else {
          return false
        }
      })
    },
    // 删除职位
    delPosition () {
      this.$commonfun.confirm(this.$t('LanguageLib.ARE_YOU_SURE_YOU_WANT_TO_DELETE_IT1'), this.$t('LanguageLib.DELETE'), this.$t('LanguageLib.DETERMINE'), this.$t('LanguageLib.CANCEL'), false, 'warning', this)
        .then(() => {
          basicdataApi.delPosition('post', '/user/deludp', {
            Ids: this.selectPositionData,
            UserId: this.userIdPosition
          })
            .then(res => {
              this.getPositionlist(this.currentPagePosition, this.pageSizePosition, this.sortPosition, this.isAscPosition, this.userIdPosition, this.searchValPosition)
              this.$message({
                type: 'success',
                message: this.$t('LanguageLib.SUCCESSFULLY_DELETED')
              })
            })
            .catch(err => {
              this.$commonfun.console.log(err)
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('LanguageLib.DeletionCancelled')
          })
        })
    },
    // 组织选择
    selectionChange (selection) {
      this.selectPositionData = []
      for (let i = 0; i < selection.length; i++) {
        this.selectPositionData.push(selection[i].id)
      }
      if (this.selectPositionData.length === 0) {
        this.delDisabled = true
      } else {
        this.delDisabled = false
      }
    },
    // 如果没有选择组织的时候给提示
    showTit () {
      this.$message({
        type: 'info',
        message: this.$t('LanguageLib.PLEASE_BEFORE_SELECT_ORGANIZATION')
      })
    }
  }
}
</script>

<style lang="scss">
  .positionList {
    .TeInput input {
      border-right: 0px;
      border-radius: 4px 0 0 4px;
    }
    .return {
      padding-left: 25px;
      position: relative;
      height: 50px;
      background: rgba(255, 255, 255, 1);
      line-height: 50px;
      border-bottom: 1px solid #F2F2F2;
      .el-icon-back {
        margin-right: 15px;
        cursor: pointer;
      }
      .border {
        position: absolute;
        height: 37px;
        border-left: 1px solid #f1f1f1;
        display: inline-block;
        top: 5px;
      }
      .title {
        height: 25px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
        margin-left: 15px;
      }
    }
    .content::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }
    .content::-webkit-scrollbar-thumb {
      border-radius: 5px;
      -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
      background: #E1E1E1;
    }
    .content::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
      border-radius: 5px;
      background: #fff;
    }
    .content {
      background: rgba(255, 255, 255, 1);
      width: 100%;
      height: calc( 100% - 66px);
      overflow-y: auto;
      padding: 0 100px 20px 100px;
      padding-top: 15px;
      box-sizing: border-box;
      .operationBtn{
        width: 100%;
        display: inline-block;
        .el-button{
          height: 30px;
          padding: 7px 20px;
        }
        .el-input{
          width: 160px;
          float: right;
          .el-input__inner{
            height: 30px;
            line-height: 30px;
            border-radius: 20px;
          }
        }
        .el-icon-search{
          line-height: 30px;
        }
      }
      .tableWarp{
        height: calc(100% - 90px);
        border: 1px solid #E1E1E1;
      }
      .tableParent{
        height: calc( 100% - 48px );
      }
      .el-pagination{
        padding: 8px 15px 5px;
        height: 35px;
        background: #fff;
      }
      .el-button--primary{
        background-color:#3BC6B9;
        color:#fff;
        border:none;
        margin-left: 10px;
      }
      .el-button--primary:hover{
        background-color:#3BC6B9;
        color:#fff;
        border:none;
      }
      /*.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
        background-color: #3BC6B9 !important;
        border-color: #3BC6B9 !important;
      }*/
      // 更改表格的滚动条样式
      .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar,
      .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
          width: 10px;
          height: 10px;
      }
      .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-thumb,
      .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-thumb {
        border-radius: 5px;
        -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
        background: #E1E1E1;
      }
      .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-track,
      .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-track {
        border-radius: 5px;
        background: #fff;
      }
      .colorG{
        height:20px;
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(59,198,185,1);
        line-height:20px;
      }
      .el-table .descending .sort-caret.descending{
        border-top-color: #3BC6B9;
      }
      .el-table .ascending .sort-caret.ascending{
        border-bottom-color: #3BC6B9;
      }
      .el-pager li.active{
        color: #3BC6B9;
      }
      .el-table__fixed-body-wrapper .el-table__body{
          padding-bottom: 10px;
      }
      .el-table-column--selection{
        text-align: center !important;
      }
      .el-tooltip__popper.is-dark{
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
        border: 1px solid #E4E7ED !important;
        background-color: #fff;
        color: #000;
        .popper__arrow{
          border-top-color: #E4E7ED;
        }
        .popper__arrow::after{
          border-top-color: #fff;
        }
      }
      // 添加职位样式
      .createPositionDialog {
        .el-dialog{
          width: 420px !important;
        }
        .el-dialog__body{
          padding-top: 0;
        }
        .el-form-item__label{
          float: none;
        }
        .el-select{
          width: 100%;
        }
        .el-button--primary{
          margin-left: 0;
        }
        .dialog-footer{
          .el-button{
            padding: 8px 14px;
          }
        }
      }
      .el-table__fixed-right{
        height: 100% !important;
      }
    }
     /*修改按钮样式*/
    .el-button--primary {
      background-color: #3BC6B9;
      border-color: #3BC6B9;
      height: 30px;
      padding: 7px 20px;
      margin-bottom: 15px;
    }
    .colorRed {
      color: red;
    }
  }
  .uploadParent{
    .el-button--primary{
      margin-bottom: 0;
    }
    .el-upload__tip{
      margin-top: 10px;
    }
  }
/*组织树视图*/
.currentOrg {
  .el-dialog{
    overflow: hidden;
    .left {
      background: #fff;
      width: 320px;
      height: 535px;
      border: 1px solid #f2f2f2;
      .fifter {
        height: 30px;
        padding: 10px 0 10px 20px;
        margin: 0 auto;
        border-bottom: 1px solid #f2f2f2;
        .el-input {
          width: 220px;
          input {
            height: 30px;
            line-height: 30px;
            border-radius: 20px;
          }
          .el-icon-search {
            line-height: 30px;
          }
        }
        .el-button--text {
          margin-left: 8px;
          padding: 7px 0;
          color: #3BC6B9;
        }
      }
      .treeBox {
        height: calc( 100% - 51px);
        overflow: auto;
        width: 320px;
      }
      .treeBox::-webkit-scrollbar {
        width: 10px;
        height: 10px;
      }
      .treeBox::-webkit-scrollbar-thumb {
        border-radius: 5px;
        -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
        background: #E1E1E1;
      }
      .treeBox::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
        border-radius: 5px;
        background: #fff;
      }
    }
  }
}
.el-table tr{
  height: 55px;
}
</style>
